import { useParams } from 'react-router-dom'

export const useOrderIdParam = () => {
  const params: any = useParams()
  return params?._id ?? undefined
}
